import React from 'react';
import PropTypes from 'prop-types';

import ReportProblemOutline from '@material-ui/icons/ReportProblemOutlined';
import BaseDialog from '../BaseDialog/BaseDialog';
import ReplaceContact from '../Replace/ReplaceContact/ReplaceContact.js';
import ReplaceMakeArrangement from '../Replace/ReplaceMakeArrangement/ReplaceMakeArrangement.js';

import { isFeatureDisabled } from '../../helpers/outageHelpers';
import { getString } from '../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const portalString = 'arrangements';

class ArrangementsDialog extends React.Component {
  render() {
    const {
      classes,
      open,
      balance,
      toggleAction,
      nextAction,
      isMaintenanceBalance,
      hasMaintenanceArrangement,
      customArrangementMessage,
      toggleContactModal,
      largeDebit,
      canCreateArrangement,
      arrangementFeatureDisabled,
      gaEventDismiss,
    } = this.props;

    const inDebit = balance < 0;
    const inCredit = balance > 0;

    const title = canCreateArrangement
      ? getString(portalString, 'ARRANGEMENT_DIALOG_DEBT_TITLE')
      : largeDebit || (hasMaintenanceArrangement && inDebit)
      ? getString(portalString, 'ARRANGEMENT_DIALOG_TITLE')
      : '';

    const buttonLabel = canCreateArrangement
      ? getString(portalString, 'MAKE_ARRANGEMENT_LABEL')
      : getString('app', 'CLOSE_LABEL');

    return (
      <React.Fragment>
        <BaseDialog
          open={open}
          title={title}
          content={
            <React.Fragment>
              {canCreateArrangement && !arrangementFeatureDisabled ? (
                <React.Fragment>
                  <ReplaceMakeArrangement
                    content={portalContent.ARRANGEMENTS_MAKE_MESSAGE}
                    action={nextAction}
                  />
                  <div className={classes.contactMessage}>
                    <ReplaceContact
                      content={portalContent.ARRANGEMENTS_MAKE_MESSAGE_2}
                      action={toggleContactModal}
                      isLink={true}
                    />
                  </div>
                </React.Fragment>
              ) : (
                <ReplaceContact
                  content={
                    customArrangementMessage
                      ? customArrangementMessage
                      : largeDebit
                      ? portalContent.ARRANGEMENTS_LARGE_DEBT_MESSAGE
                      : isMaintenanceBalance && inDebit
                      ? portalContent.DASH_REPAIRS_NEGATIVE
                      : isMaintenanceBalance && inCredit
                      ? portalContent.DASH_REPAIRS_POSITIVE
                      : hasMaintenanceArrangement && inDebit
                      ? portalContent.ARRANGEMENTS_HAS_MAINTENANCE_MESSAGE
                      : inDebit
                      ? portalContent.DASH_RENT_NEGATIVE
                      : portalContent.DASH_RENT_POSITIVE
                  }
                  action={toggleContactModal}
                  isLink={true}
                />
              )}
            </React.Fragment>
          }
          buttonAction={canCreateArrangement ? nextAction : toggleAction}
          buttonLabel={buttonLabel}
          buttonCustomClass={classes.buttonCustomClass}
          secondaryButtonAction={
            canCreateArrangement
              ? () => {
                  if (gaEventDismiss) {
                    gaEventDismiss();
                  }
                  toggleAction();
                }
              : null
          }
          secondaryButtonLabel={getString('app', 'CLOSE_LABEL')}
          icon={ReportProblemOutline}
          isHTML={true}
          centre={true}
          contentWrap={false}
        />
      </React.Fragment>
    );
  }
}

ArrangementsDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  balance: PropTypes.number.isRequired,
  isMaintenanceBalance: PropTypes.bool,
  hasMaintenanceArrangement: PropTypes.bool,
  customArrangementMessage: PropTypes.string,
  canCreateArrangement: PropTypes.bool,
  largeDebit: PropTypes.bool,
  arrangementFeatureDisabled: PropTypes.bool,
  toggleAction: PropTypes.func.isRequired,
  nextAction: PropTypes.func.isRequired,
  toggleContactModal: PropTypes.func.isRequired,
  gaEventDismiss: PropTypes.func,
};

ArrangementsDialog.defaultProps = {
  isMaintenanceBalance: false,
  hasMaintenanceArrangement: false,
  canCreateArrangement: false,
  largeDebit: false,
  arrangementFeatureDisabled: false,
  customArrangementMessage: null,
  gaEventDismiss: null,
};

export default withStyles(styles)(ArrangementsDialog);
